import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';

import { User } from 'models';
import { validate } from 'models/validate';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';

import {getDateToTimestamp, getTimestampToDate, keyedObjToArr} from '../util';

import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';

import Input from './Input';
import DatePicker from 'react-datepicker';

class UserPanel extends Component {

	constructor (props) {
		super(props);
		let user = this.props.user || {
		    role: 'teacher',
            disabled: false,
            trial: false
        };

		this.state = {
			user : user
		};

	}

	updateUserCustomer (option) {
		let user = this.state.user;
		user.customer = option.value;
		this.setState({
			user : user
		});
	}

	updateUser (event) {
		let user = this.state.user;
		user[event.target.name] = event.target.value;
		this.setState({
			user : user
		});
	}

	toggleUserDisabled (event) {
		let user = this.state.user;
		user.disabled = !!event.target.checked;
		this.setState({
			user : user
		});
	}

    toggleUserTrial (event) {
		let user = this.state.user;
		user.trial = !!event.target.checked;
		this.setState({
			user : user
		});
	}

    updateTrialEndDate(date) {
        let user = this.state.user;
        user.trialEndDate = getDateToTimestamp(date);
        this.setState({
            user: user
        });
    }

	render () {
		if(!isLoaded(this.props.products) || !isLoaded(this.props.customers)) {
			return false;
		}

		let customerOptions = keyedObjToArr(this.props.customers).map( (customer) => {
			return {label : customer.name, value : customer.id};
		});

		let roleOptions = [
			{label : 'Admin', value : 'admin'},
			{label : 'Customer', value : 'customer'},
			{label : 'Teacher', value : 'teacher'}
		];

		let userRole = this.state.user.role;
		let userTrial = this.state.user.trial;

		return (
			<div className="panel">
				<ContentHeader
					title={this.props.editing ? 'Editing ' + this.state.user.name : 'Create New User'}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">
						<PanelSectionWithLabel className="panel-section" label="Name" header="Account Info">
							<Input
								value={this.state.user.name}
								placeholder="Name"
								name="name"
								onChange={this.updateUser.bind(this)}
							/>
						</PanelSectionWithLabel>
						<PanelSectionWithLabel label="Email">
							<Input
								value={this.state.user.email}
								name="email"
								placeholder="Email"
								onChange={this.updateUser.bind(this)}
							/>
						</PanelSectionWithLabel>
						{!this.props.editing ? (
							<PanelSectionWithLabel label="Password">
								<Input
									type="password"
									name="password"
									value={this.state.user.password}
									placeholder="••••••••••"
									onChange={this.updateUser.bind(this)}
								/>
							</PanelSectionWithLabel>
						) : false}
						<PanelSectionWithLabel label="Disabled">
							<Input
								type="toggle"
								name="disabled"
								checked={this.state.user.disabled}
								value={this.state.user.disabled}
								offLabel="No"
								onLabel="Yes"
								onChange={this.toggleUserDisabled.bind(this)}
							/>
						</PanelSectionWithLabel>
						<PanelSectionWithLabel label="Trial">
                            <Input
                                type="toggle"
                                name="trial"
                                checked={this.state.user.trial}
                                value={this.state.user.trial}
                                offLabel="No"
                                onLabel="Yes"
                                onChange={this.toggleUserTrial.bind(this)}
                            />
						</PanelSectionWithLabel>
                        {userTrial && (
                            <PanelSectionWithLabel label="End Date">
                                <DatePicker
                                    selected={getTimestampToDate(this.state.user.trialEndDate)}
                                    onChange={this.updateTrialEndDate.bind(this)}
                                />
                            </PanelSectionWithLabel>
                        )}
						<PanelSection header="User Role">
							<Input
								type="select"
								placeholder="Role"
								name="role"
								value={this.state.user.role}
								onChange={this.updateUser.bind(this)}
								options={roleOptions}
							/>
						</PanelSection>
                        {userRole !== 'admin' && (
                            <PanelSection header="Customer">
                                <Input
                                    type="typeahead"
                                    placeholder="Customer"
                                    name="customer"
                                    value={this.state.user.customer}
                                    onChange={this.updateUserCustomer.bind(this)}
                                    options={customerOptions}
                                />
                            </PanelSection>
                        )}
					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					confirmLabel="Save User"
					onCancel={this.props.onCancel}
					onConfirm={function () {
						validate(this.state.user, User).then( (validatedUser) => {
							if(this.props.editing) {
								this.props.saveUser(validatedUser);
								this.props.addNotification('add-save-user-success-' + Date.now(), 'User Saved');
							} else {
								if(this.props.addUser(validatedUser)){
                                    this.props.addNotification('add-save-user-success-' + Date.now(), 'User Added');
								}
                                else {
                                    this.props.addNotification('add-save-user-error-' + Date.now(), 'Unable to create new user');
                                }
                                this.props.closeDrawer();
							}

						}).catch( (error)=> {
							console.log(error.message);
							this.props.addNotification('add-save-user-error-' + Date.now(), error.message);
						});

					}.bind(this)}
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

const fbWrappedComponent = firebaseConnect([
	'/customers',
	'/products',
	'/classrooms'
])(UserPanel);

export default connect(
({ firebase }) => ({
		customers: dataToJS(firebase, 'customers'),
		products: dataToJS(firebase, 'products'),
		classrooms: dataToJS(firebase, 'classrooms')
	}),
	mapDispatchToProps
)(fbWrappedComponent);


// WEBPACK FOOTER //
// ./js/components/UserPanel.js